import {newStepValue} from '../../../../services/flowBuilder/utils/constants';
export const contactReceiving= {
    json: {
        menu: {
            menuType: 'contactReceiving',
            name: '',
            text: '',
            menuParams: {
                validationMessage: '',
                direction: 'inbound',
                address: false,
                validateFields: {
                    name: false,
                    phone: false,
                    email: false,
                    birthday: false,
                    url: false,
                    organisation: false
                },
            },
        },
        type: 'menu',
        next: newStepValue,
    },
    paths: [
        'menu.text',
        'menu.name',
        'menu.menuParams.direction',
        'menu.menuParams.validationMessage',
        'menu.menuParams.validateFields.name',
        'menu.menuParams.validateFields.phone',
        'menu.menuParams.validateFields.email',
        'menu.menuParams.validateFields.birthday',
        'menu.menuParams.validateFields.birthday',
        'menu.menuParams.validateFields.url',
        'menu.menuParams.validateFields.organisation',
    ],
    groups: [
        {
            Parameters: [
                'menu.bodyText',
                'menu.name',
                'menu.menuParams.direction',
                'menu.menuParams.validationMessage',
                'menu.menuParams.validateFields.name',
                'menu.menuParams.validateFields.phone',
                'menu.menuParams.validateFields.email',
                'menu.menuParams.validateFields.birthday',
                'menu.menuParams.validateFields.birthday',
                'menu.menuParams.validateFields.url',
                'menu.menuParams.validateFields.organisation',
            ],
        },
        {
            Logic: ['next'],
        },
    ],
};